import { render, staticRenderFns } from "./IconArrowSmallRight.vue?vue&type=template&id=56af9cfd&scoped=true&"
import script from "./IconArrowSmallRight.vue?vue&type=script&lang=ts&"
export * from "./IconArrowSmallRight.vue?vue&type=script&lang=ts&"
import style0 from "./IconArrowSmallRight.vue?vue&type=style&index=0&id=56af9cfd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56af9cfd",
  null
  
)

export default component.exports